import {Configuration, LogLevel} from '@azure/msal-browser';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: '8e72eed2-fc85-469a-ad8c-02d42da81ac7', // 'e5d67ce6-731a-4c81-bb05-4e766b820ae1', //'68554e49-5216-435d-bcf5-5db911652104', // Application (client) ID from your Azure AD App Registration
    authority:
      'https://login.microsoftonline.com/cd6282b3-8a1b-40f0-9992-593dec57dd10', // Your Azure AD tenant ID
    redirectUri: location.origin, //'https://thankful-plant-07c61c803-preview.westeurope.5.azurestaticapps.net', // Explicit redirect URI for local development
    postLogoutRedirectUri: location.origin, //'https://thankful-plant-07c61c803-preview.westeurope.5.azurestaticapps.net',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // or "localStorage"
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Add scopes here for ID token to be used at Microsoft Graph API endpoints.
export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'api://8e72eed2-fc85-469a-ad8c-02d42da81ac7/user_impersonation',
  ], // Basic Microsoft Graph permissions + API access
};

// Scopes for your backend API
export const apiRequest = {
  scopes: ['api://8e72eed2-fc85-469a-ad8c-02d42da81ac7/user_impersonation'],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
